module.exports = __webpack_public_path__ + "media/images/Tote-bag-coffret-cadeaux-hortense-6c852d7758e2a1d191215ff2f28fb161.webp";